import { Row, Col } from 'antd'
import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from 'react'
import Http from "@/utils/http";
import ConstValue from "@/utils/value";
import './index.scss'
import NavLink from '@/components/NavLink'

export default function ProductsNew3() {
  const [info, setInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate()
  const location = useLocation();
  
  // 直接从路径中解析参数并使用decodeURIComponent解码
  const pathParts = location.pathname.split('/').filter(part => part);
  console.log('路径分割:', pathParts);
  
  // 根据您的路由结构提取参数并解码
  let classification, rate;
  if (pathParts.length >= 3 && pathParts[0] === 'solutionPage2') {
    // 使用 decodeURIComponent 解码URL编码的参数
    classification = decodeURIComponent(pathParts[1]);
    rate = decodeURIComponent(pathParts[2]);
  } else {
    // 如果路径格式不对，显示错误
    classification = 'Unknown';
    rate = 'Unknown';
  }
  
  console.log('解码后的参数:', { classification, rate });

  useEffect(() => {
    // 只有当参数有效时才获取数据
    if (classification && classification !== 'Unknown' && 
        rate && rate !== 'Unknown') {
      getInfo();
    }
  }, [classification, rate]);

  const getInfo = async () => {
    setLoading(true);
    setError(null);
    
    try {
      console.log('开始获取数据...');
      console.log('分类:', classification, '速率:', rate);
      
      // 尝试更简单的过滤方式 - 直接过滤 Part_No 为空字符串
      const filter = {
        'classification': classification,
        'Part_No': '' // 直接使用空字符串过滤
      };
      
      // 如果 rate 不是 "Unknown"，添加到筛选条件
      if (rate && rate !== 'Unknown') {
        filter['Rate'] = rate;
      }
      
      console.log('筛选条件:', filter);
      
      let res = await Http.to.items("Product_new").readByQuery({
        fields: ['*'],
        filter: filter
      });
      
      console.log('API响应:', res);
      
      // 如果服务器端过滤成功，直接使用数据
      // 如果不成功，在客户端再次过滤
      let filteredData = res.data || [];
      if (filteredData.length > 0) {
        // 确保数据确实符合 Part_No 为空的条件
        filteredData = filteredData.filter(item => !item.Part_No || item.Part_No === '');
      }
      
      setInfo(filteredData);
    } catch (error) {
      console.error('获取数据失败:', error);
      
      // 如果直接过滤失败，尝试不使用 Part_No 过滤
      getInfoWithoutPartNoFilter();
    } finally {
      setLoading(false);
    }
  }

  // 不使用 Part_No 过滤的备选方法
  const getInfoWithoutPartNoFilter = async () => {
    try {
      const filter = {
        'classification': classification
      };
      
      if (rate && rate !== 'Unknown') {
        filter['Rate'] = rate;
      }
      
      console.log('备选筛选条件:', filter);
      
      let res = await Http.to.items("Product_new").readByQuery({
        fields: ['*'],
        filter: filter
      });
      
      // 在客户端过滤 Part_No 为空的数据
      let arr = [];
      res.data.forEach((item) => {
        if (!item.Part_No || item.Part_No === '') {
          arr.push(item)
        }
      })
      
      setInfo(arr);
    } catch (error) {
      console.error('备选方法也失败:', error);
      setError('获取产品数据失败: ' + error.message);
    }
  }

  const toProducts3 = (id) => {
    navigate('/productsInfo/' + id);
  };

  const toPage = (address) => {
    if (address.indexOf('http') !== -1) {
      window.open(address);
      return;
    }
    navigate('/' + address);
  }

  const geturl = (url) => {
    return url ? url.split(';')[0] : '';
  }

  return (
    <div className='products_new3'>
      {/* 面包屑导航 - 始终显示 */}
      <NavLink 
        title1={'Products · Solution'} 
        link1={() => { toPage('Solution') }} 
        title2={classification} 
        title3={rate} 
        link2={() => { navigate(-1) }} 
      />
      
      {/* 顶部信息 - 始终显示 */}
      <div className='top_info'>
        <div>
          {classification} - {rate}
        </div>
      </div>
      
      <div className='info'>
        <Row justify={'center'}>
          <Col sm={24} xl={12} className="productnewlist">
            {/* 错误信息 */}
            {error && (
              <div className="error-message">
                <h3>Loading failed</h3>
                <p>{error}</p>
                <button onClick={getInfo}>retry</button>
              </div>
            )}
            
            {/* 加载状态 */}
            {loading && (
              <div className="loading-message">
                <p>Loading...</p>
              </div>
            )}
            
            {/* 无参数错误 */}
            {(!classification || classification === 'Unknown' || !rate || rate === 'Unknown') && !loading && (
              <div className="parameter-error">
                <h3>URL parameter error</h3>
                <button onClick={() => navigate('/Solution')}>Return to the Solution Page</button>
              </div>
            )}
            
            {/* 产品列表 */}
            {!loading && !error && classification && classification !== 'Unknown' && rate && rate !== 'Unknown' && (
              <div className='items'>
                {info.map((item, index) => (
                  <div key={index} className='item' onClick={() => toProducts3(item?.id)}>
                    <div className='img-container'>
                      <div className='img' style={{ backgroundImage: `url(${ConstValue.url + "assets/" + geturl(item.img)})` }}>
                        <div className='mask'></div>
                      </div>
                    </div>
                    <div className='info_item'>
                      <span className='title'>{item?.Name}</span>
                      <span className='description' dangerouslySetInnerHTML={{ __html: item?.Features }}></span>
                      <span className='readmore' onClick={() => toProducts3(item?.id)}>
                        READ MORE<span></span>
                      </span>
                    </div>
                  </div>
                ))}
                
                {info.length === 0 && (
                  <div className="no-data">
                    <p>Data loading ...</p>
                    <p>Classification: {classification}</p>
                    <p>Rate: {rate}</p>
                  </div>
                )}
              </div>
            )}
          </Col>
        </Row>
      </div>
    </div>
  )
}